export enum SurveyVariableConditionFrequencyEnum {
  Unique = 'unique',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly',
}

export const SurveyVariableConditionFrequencyEnumLabels: Record<SurveyVariableConditionFrequencyEnum, string> = {
  [SurveyVariableConditionFrequencyEnum.Unique]: 'Único',
  [SurveyVariableConditionFrequencyEnum.Monthly]: 'Mensual',
  [SurveyVariableConditionFrequencyEnum.Quarterly]: 'Trimestral',
  [SurveyVariableConditionFrequencyEnum.Yearly]: 'Anual',
};
